//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveWorkOrderResultRecord } from '../../../../api/workOrder';
import fileUploader from '@/views/common-components/file-uploader';

export default {
    name: 'page-result-view',
    components: { fileUploader },
    props: {
        workOrderId: {
            required: true,
            type: Number,
            rules: {}
        }
    },
    data() {
        return {
            workOrderResults: [],
            showCreateResultRecord: false,
            showChangeStatusModal: false,
            resultRecordInputDto: {},
            saveResultDto: {
                id: 0,
                image: {}
            },
            saving: false,
            rules: {}
        };
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        onSaveWorkOrderResultRecord() {
            this.resultRecordInputDto.id = 0;
            this.resultRecordInputDto.workOrderId = this.id;
            if (this.workOrderInfo.status === 2) {
                this.resultRecordInputDto.operationType = 6;
            } else {
                this.resultRecordInputDto.operationType = 8;
            }
            var vm = this;
            vm.saving;
            saveWorkOrderResultRecord(vm.resultRecordInputDto).then(() => {
                vm.showCreateResultRecord = false;
                vm.getWorkOrderResults();
            }).finally(() => {
                vm.saving = false;
            });
        },
        showCreateResultView() {
            if (this.workOrderInfo.status === 0 || this.workOrderInfo.status === 1 || this.workOrderInfo.status === 3 || this.workOrderInfo.status === 4) {
                this.$Message.warning('工单状态需为“延迟完结”或“正常完结”！');
                return;
            }
            this.saving = false;
            this.resultRecordInputDto = {};
            this.showCreateResultRecord = !this.showCreateResultRecord;
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },
        getWorkOrderResults() {
            var vm = this;
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderResults',
                id: this.workOrderId
            }).then(() => {
                vm.workOrderResults = vm.$store.state.workOrder.workOrderResults;
            });
        },
        onSaveResult() {
            const vm = this;
            vm.saveResultDto.workOrderId = vm.workOrderId;
            abp.ajax.post('/api/services/app/WorkOrder/SaveWorkOrderResult', this.saveResultDto).then(res => {
                // vm.showSaveResultModel = false;
                vm.showChangeStatusModal = false;
                vm.getWorkOrderResults();
                vm.$emit('saveSuccess');
                vm.$emit('onRefreshOperationLog')
                // if (vm.workOrderInfo.workOrderType == 2) {
                //     vm.$refs.delayRecordsRef.getDelays();
                // }

            }).finally(() => {
                // vm.saveFeedbackRecording = false;
            });
        },
        show() {
            this.saveResultDto = {
                image: {},
                status: this.workOrderInfo.status
            };
            this.showChangeStatusModal = true;
        },
        delayTimeChange(date) {
            this.delayRecord.delayTime = date;
        }
    },
    created() {
        // this.getWorkOrderResults();
    },
    watch: {
        // workOrderId(value, oldValue) {
        //     if (value > 0) {
        //         this.workOrderId=value;
        //         this.getWorkOrderResults();
        //     }
        // }
    }
};
